import { NgModule } from '@angular/core';

import { DialogLayoutComponent } from './dialog-layout.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatToolbarModule } from '@angular/material/toolbar';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    imports: [CommonModule, MatDialogModule, MatIconModule, MatToolbarModule, TranslateModule],
    exports: [DialogLayoutComponent],
    declarations: [DialogLayoutComponent]
})
export class DialogLayoutModule {}
